import { annotationsSchema } from 'components/ChartTools/Annotations/schema';
import { CHART_METRIC_MIXED_TYPES } from 'components/ChartTools/ViewSettings/constants';
import { viewSettingsSchema } from 'components/ChartTools/ViewSettings/schema';

import {
  object,
  array,
  string,
  collection,
  boolean,
  number,
} from '@gogame/schemas';

import {
  CHART_SETTINGS_CHANGE_RATE_MODE,
  CHART_SETTINGS_CHART_GROUPING,
  CHART_SETTINGS_INCLUDE_CHANGE_RATE,
  CHART_SETTINGS_LOOKBACK_MODE,
  CHART_SETTINGS_OUTPUT,
  CHART_SETTINGS_SCALE,
  CHART_SETTINGS_TREND,
  CHART_SETTINGS_WEEK_START_DAY,
  START_DAY_MON,
} from '../components/TrackerCharts/Chart/Actions/ChartSettings/constants';

const settingsSchema = object(
  {
    [CHART_SETTINGS_OUTPUT]: string().default('values'),
    [CHART_SETTINGS_SCALE]: string().default('daily'),
    [CHART_SETTINGS_LOOKBACK_MODE]: string().default('0'),
    [CHART_SETTINGS_TREND]: boolean().default(false),
    [CHART_SETTINGS_INCLUDE_CHANGE_RATE]: boolean().default(false),
    [CHART_SETTINGS_CHANGE_RATE_MODE]: string().default('default'),
    [CHART_SETTINGS_CHART_GROUPING]: string().default('0'),
    [CHART_SETTINGS_WEEK_START_DAY]: string().default(START_DAY_MON),
  },
  'settings'
);

export const chartBreakdownSchema = object({
  breakdownMetric: string(),
  topItemsCount: number(),
});

export const chartSchema = object(
  {
    breakdownMode: boolean().default(false),
    metrics: array(string()).default([]),
    settings: settingsSchema,
    chartViewSettings: viewSettingsSchema.namespace('chartViewSettings'),
    breakdown: chartBreakdownSchema.default({}),
    annotations: annotationsSchema,
    width: number(),
    lazy: boolean().default(false),
  },
  'chart'
);

const DEFAULT_CHART_METRIC = 'TotalRegs';

export const chartsSchema = collection(chartSchema).default([
  {
    ...chartSchema.default(),
    metrics: [DEFAULT_CHART_METRIC],
    chartViewSettings: {
      ...viewSettingsSchema.default(),
      [CHART_METRIC_MIXED_TYPES]: [{ id: DEFAULT_CHART_METRIC, type: 'line' }],
    },
    width: 100,
  },
]);
